import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { MuiThemeProvider } from "@material-ui/core/styles";
import { Tooltip as MaterialTooltip } from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { tooltipSizes } from "core/props";

import Title from "./Title";
import {
    TooltipContainer,
    tooltipThemeStyles,
    StyledChildrenContainer
} from "./styles";

const UnstyledTooltip = ({
    darkMode = false,
    size = "large",
    message,
    children,
    className
}) => {
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(!open);
    };

    const isSmallTooltip = size === "small";

    const largeTooltipProps = !isSmallTooltip && {
        open: open,
        onClose: handleTooltipClose,
        disableFocusListener: true,
        disableHoverListener: true,
        disableTouchListener: true
    };

    return (
        <MuiThemeProvider
            theme={tooltipThemeStyles({ darkMode, isSmallTooltip })}
        >
            <TooltipContainer className={className}>
                <ClickAwayListener onClickAway={handleTooltipClose}>
                    <MaterialTooltip
                        arrow
                        interactive
                        title={
                            <Title
                                darkMode={darkMode}
                                message={message}
                                isSmallTooltip={isSmallTooltip}
                            />
                        }
                        {...largeTooltipProps}
                    >
                        <StyledChildrenContainer
                            onClick={isSmallTooltip ? null : handleTooltipOpen}
                        >
                            {children}
                        </StyledChildrenContainer>
                    </MaterialTooltip>
                </ClickAwayListener>
            </TooltipContainer>
        </MuiThemeProvider>
    );
};

const Tooltip = styled(UnstyledTooltip)``;

Tooltip.propTypes = {
    size: PropTypes.oneOf(tooltipSizes),
    darkMode: PropTypes.bool,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.element
};

export default Tooltip;
